import I18nContext from './I18nContext';
export default I18nContext.Provider;
